import { createFileRoute } from "@tanstack/react-router";
import { NewAppDialog } from "@/components/NewAppDialog";

export const Route = createFileRoute("/_app/new-app")({
	head: () => ({
		meta: [{ title: "New App - Biteasy" }],
	}),
	component: NewAppDialog,
});
